import { createSlice } from "@reduxjs/toolkit";

interface IAppStateSlice {
	selectedClient: { id: string; name: string };
	selectedBuilding: {
		id: string;
		name: string;
		address: string;
		city: string;
		state: string;
		zip: string;
		clientId: string;
		clientName: string;
		siteId: string;
		siteName: string;
		floors: any;
	};
	selectedFloor: {
		id: string;
		name: string;
		clientId: string;
		clientName: string;
		siteId: string;
		siteName: string;
		buildingId: string;
		buildingName: string;
	};
	selectedSpace: { id: string; name: string; metadata: {}; devices: [] };
	error: string;
}

export const appStateSlice = createSlice({
	name: "appState",
	initialState: {
		selectedClient: { id: "", name: "" },
		selectedBuilding: {
			id: "",
			name: "",
			address: "",
			city: "",
			state: "",
			zip: "",
			clientId: "",
			clientName: "",
			siteId: "",
			siteName: "",
			floors: [],
		},
		selectedFloor: {
			id: "",
			name: "",
			clientId: "",
			clientName: "",
			siteId: "",
			siteName: "",
			buildingId: "",
			buildingName: "",
		},
		selectedSpace: { id: "", name: "", metadata: {}, devices: [] },
	} as IAppStateSlice,
	reducers: {
		selectClient: (
			state: any,
			action: { payload: { id: string; name: string } }
		) => {
			state.selectedClient = {
				id: action.payload.id,
				name: action.payload.name,
			};
		},
		selectBuilding: (
			state: any,
			action: {
				payload: {
					id: string;
					name: string;

					address: string;
					city: string;
					state: string;
					zip: string;

					floors: any[];

					clientId: string;
					clientName: string;
					siteId: string;
					siteName: string;
				};
			}
		) => {
			state.selectedBuilding = {
				id: action.payload.id,
				name: action.payload.name,

				address: action.payload.address,
				city: action.payload.city,
				state: action.payload.state,
				zip: action.payload.zip,

				clientId: action.payload.clientId,
				clientName: action.payload.clientName,
				siteId: action.payload.siteId,
				siteName: action.payload.siteName,
			};
		},
		selectFloor: (
			state: any,
			action: {
				payload: {
					clientId: string;
					clientName: string;
					siteId: string;
					siteName: string;
					buildingId: string;
					buildingName: string;
					id: string;
					name: string;
				};
			}
		) => {
			state.selectedFloor = {
				clientId: action.payload.clientId,
				clientName: action.payload.clientName,
				siteId: action.payload.siteId,
				siteName: action.payload.siteName,
				buildingId: action.payload.buildingId,
				buildingName: action.payload.buildingName,
				id: action.payload.id,
				name: action.payload.name,
			};
		},
		selectSpace: (
			state: any,
			action: {
				payload: {
					id: string;
					name: string;
					devices: any[];
					metadata: any;
				};
			}
		) => {
			state.selectedSpace = {
				id: action.payload.id,
				name: action.payload.name,
				devices: action.payload.devices,
				metadata: action.payload.metadata,
			};
		},
	},
});

export const { selectClient, selectBuilding, selectFloor, selectSpace } =
	appStateSlice.actions;

export default appStateSlice.reducer;
